import { Box, Heading, SimpleGrid } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDetails } from "../../../hooks/useDetails.ts";
import CardItem from "../../card/cartdItem.tsx";

const EventsSection = () => {
    const { t } = useTranslation();
    const { data } = useDetails();

    return (
        <Box padding={{ base: "60px 20px", md: "120px 120px" }}>
            <Heading
                textAlign="center"
                mb="30px"
                fontSize={{ base: "28px", md: "48px" }}
            >
                {t("Premium")} <span style={{ color: "#66F5FF" }}>{t("Events")}</span>
            </Heading>
            <SimpleGrid
                columns={{ base: 1, sm: 2, md: 3 }}
                spacing={{ base: "30px", md: "60px" }}
            >
                {data?.body?.map((event, index) => (
                    <CardItem {...event} key={index} />
                ))}
            </SimpleGrid>
        </Box>
    );
};

export default EventsSection;
